import { Card, CardContent } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { type DocumentIngestionPipelineFilter } from "../../../generated/graphql";
import { useOnScreen } from "../../common/use-on-screen";
import CompanyStatistics from "./company-statistics";
import { type StatisticsView } from "./utils";

const CompanyStatisticsCard = ({
  tab,
  companyName,
  companyUuid,
  pipeline,
}: {
  readonly tab: StatisticsView;
  readonly companyName: string;
  readonly companyUuid: string;
  readonly pipeline: DocumentIngestionPipelineFilter;
}) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const isVisible = useOnScreen(cardRef);
  const [shouldRender, setShouldRender] = useState<boolean>(false);
  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
    }
  }, [isVisible]);

  return (
    <Card ref={cardRef} variant="outlined" sx={{ minHeight: 855 }}>
      <CardContent sx={{ pt: 0, px: 1 }}>
        {shouldRender && (
          <CompanyStatistics
            companyName={companyName}
            companyUuid={companyUuid}
            tab={tab}
            pipeline={pipeline}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default CompanyStatisticsCard;
